import login from './login';

export default {
  language: 'tr',
  country: 'tr',
  name: 'Türkçe',
  embeddedLocale: login,
};
